import * as types from '../constants/commonConstants';
import moment from 'moment-timezone';
const arr = [];
let openedArray = [];
const initialState = {
  newsFeedData : [],
  forcedLogout:false,
  killSession:{Key:false,Msg:"",Flag:false},
  // settingmodal:false,
  setLockState:false,
  openedWidgets:[],
  openCalender:false,
  widgetKeyValue:'',
  errorMsgArr:[],
  errorLogs: [],
  addPayReqFlag:false,
  editPayReqFlag:false,
  navigationStatus:'',
  nonTradedStk:[],
};

const setWidgetTheme = (theme) => {
  const themePreview = {};
  return themePreview;
};
const closeAllChilds = (child) => {
  arr.push(child);
  return arr;
};
const openedWidget = (key, state) => { 
  if (state === 'open') {
    openedArray.push(key);
  } else {
    openedArray = openedArray.filter((item) => {
      return item !== key;
    });
  }
  localStorage.setItem('openedWidgets', JSON.stringify(openedArray));
  return openedArray;
};
const updateNewsFeedData = (newsFeedData,message) =>{
  const item =Object.assign([],newsFeedData);
  const msg=message;
  if(msg.PT==="A"){
    var obj={};
    obj.nf_id=msg.ID;
    obj.NF=msg.MSG;
    obj.URL=msg.URL;
    obj.CT=parseFloat(msg.TS);
    item.push(obj);
  }
  if(msg.PT==="E"){
      for (let index = 0; index < item.length; index++) {
          if (item[index].nf_id == msg.ID) {
                item[index].NF=msg.MSG;
                item[index].URL=msg.URL;
                item[index].CT=parseFloat(msg.TS);
                break;
            }
      }
  }
  if(msg.PT==="D")
  {
    for (let index = 0; index < item.length; index++) {
        if (item[index].nf_id == msg.ID) {
          item.splice(index,1);
          break;
        }
      }
  }
  localStorage.setItem('newsFeedData', JSON.stringify(item));
  return item;
};


export default function(state = initialState, action)  {
  switch (action.type) {
    case types.WIDGET_THEMING_SUCCESS:
      localStorage.setItem('openedWidgets', []);
      return {
        ...state,
        themePreview: setWidgetTheme(action.value)
      };
    case types.WIDGET_THEMING_FAILURE:
      return {
        ...state,
      };
    case types.GET_WIDGET_THEMING:
      return {
        ...state,
      };
    case types.GET_WIDGET_THEMING_SUCCESS:
      return {
        ...state,
        themePreview: setWidgetTheme(action.result.data)
      };
    case types.GET_WIDGET_THEMING_FAILURE:
      return {
        ...state,
      };
    case types.HANDLE_MODAL:
      return {
        ...state,
        modal: action.status
      };

    case types.HIDE_MODAL:
      return {
        ...state,
        modal: false
      };
    case types.SHOW_DIALOG:
      return {
        ...state,
        showDialog: true
      };
    case types.HIDE_DIALOG:
      return {
        ...state,
        showDialog: false
      };
    case types.NAVIGATE_TRADE_REPORT:
      return {
        ...state,
        navigationStatus: action.option,
      };
    case types.POPUP_WINDOW_HANDLE:
	    return {
	      ...state,
	      handler: closeAllChilds(action.opened),
	      poppedOut: action.opened,
	      openedWidgets: openedWidget(action.key, 'open')
    };
    case types.POPUPCLOSE_HANDLE:
    	return {
  	  ...state,
      openedWidgets: openedWidget(action.key, 'close')
	    };
    case types.LOAD_NEWSFEED:
        return {
          ...state
        };
      case types.LOAD_NEWSFEED_SUCCESS:
        localStorage.setItem('newsFeedData', JSON.stringify(action.result.data));
        localStorage.setItem('openedWidgets', []);
          return {
          ...state,
          newsFeedData:action.result.data
        };
      case types.LOAD_NEWSFEED_FAILURE:
            return {
            ...state
          };
      case types.UPDATE_NEWSFEED:
       return{
        ...state,
        newsFeedData:updateNewsFeedData(state.newsFeedData,action.message)
    };
    case types.FORCED_LOGOUT:
     return {
       ...state,
       forcedLogout:true
     }
     case types.CL_FORCED_LOGOUT:
     return{
       ...state,
       forcedLogout:false
     }
     case types.NOCHANGE:
     return{
       ...state,
     }
     case types.KILL_SESSION:
     var obj={};
     obj.Key=action.key;
     obj.Msg=action.msg;
     obj.Flag=action.flag;
     return{
       ...state,
       killSession:obj,
     };
	 case types.CLEAR_KILL_SESSION:
	 var obj={};
     obj.Key=false;
     obj.Msg="";
     obj.Flag=false;
	 return{
       ...state,
       killSession:obj,
     };
     case types.LOAD_LOCK_FLAG:
     //alert("in reducer flag is "+action.flag);
     return{
       ...state,
       setLockState:action.flag
     }
     case types.CHANGE_CALENDAR_FLAG:
     return{
       ...state,
       openCalender:action.flag,
       widgetKeyValue:action.keyValue
     }
     case types.LOG_FILE_CREATE:
     return{
       ...state,
       errorLogs: [...state.errorLogs, action.errorObj]
     }
     case types.SEND_LOG:
     return{
       ...state,
     }
     case types.SEND_LOG_SUCCESS:
     return{
       ...state,
       errorLogs:[]
     }
     case types.SEND_LOG_FAILURE:
     return{
       ...state,
     }
     case types.GET_NONTRADEDSTK_LIST:
     return {
     ...state,
     };
     case types.GET_NONTRADEDSTK_LIST_SUCCESS:
     return {
     ...state,
     nonTradedStk:action.result.data,
     };
     case types.GET_NONTRADEDSTK_LIST_FAILURE:
     return {
     ...state,
    };
     default:
		    return state;
		}
  }
